import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function MySpaceSingle() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const snap = await getDoc(doc(db, "myspace", id));
        if (snap.exists()) {
          setData(snap.data());
        } else {
          setData(null); // optional: handle 404
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchOne();
  }, [id]);

  if (loading) return (
    <div className="text-center mt-40 text-lg">Loading...</div>
  );

  if (!data) return (
    <div className="text-center mt-40 text-lg">Content not found.</div>
  );

  return (
    <div className="max-h-screen mb-[120px] bg-white mt-[140px]">
      <div className="max-w-3xl mx-auto">

        {/* Image */}
        {data?.image && (
          <img
            src={data.image}
            alt={data?.title || "MySpace Image"}
            className="w-full h-64 object-cover rounded-xl mb-6"
          />
        )}

        {/* Title */}
        <h1 className="text-4xl font-bold mb-4">
          {data?.title}
        </h1>

        {/* Meta */}
        <p className="text-sm">
          By <strong>{data?.author}</strong> • {data?.type}
        </p>

        {/* About Author */}
        {data?.aboutauthor && (
          <div className="border-t mt-4 pt-4">
            <p className="text-sm text-gray-700">{data.aboutauthor}</p>
          </div>
        )}

        {/* Full Content */}
        <div className="leading-relaxed whitespace-pre-line text-lg mt-8">
          {data?.full}
        </div>
      </div>
    </div>
  );
}
